import { Carriers } from '../constants/carriers';
import { Products } from '../constants/products';
import { UserOrganization } from '../constants/userOrganization';
import { ProductConfig } from './productConfig';

export class SeniorLifeSIWL extends ProductConfig {
  getCarrier(): Carriers {
    return Carriers.SENIOR_LIFE;
  }
  getProduct(): Products {
    return Products.SIWL;
  }
  availableToOrganization(org: UserOrganization): boolean {
    return [UserOrganization.SENIOR_LIFE, UserOrganization.ETHOS].includes(org);
  }
  showInErrorTasks(): boolean {
    return false;
  }
  medicalClaimAvailable(): boolean {
    return false;
  }
  getColor(): string {
    return 'FeGreen';
  }
  automatedCriminalRecordsAvailable(): boolean {
    return false;
  }
  hasDebits(): boolean {
    return false;
  }
}
